import FirebaseService from "./firebase-service";

const mainService = new FirebaseService();

export default mainService;
